import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { checkParam } from 'shared/utils/checkParam'
import { getDateTimeReadFormat, getDateTimeToSubmit } from 'shared/utils/dateFormatting'
import { api } from 'api'
import { exportExcelFile } from 'shared/utils/exportExcelFile'
import { PAYMENT_TYPE_LABEL, PAYMENT_STATE_LABEL } from 'shared/constants/payments'
import { columns } from './columns'

export const useFetchData = (size: any, filter: any) => {

  const payload = {
    size,
    page: 0,
    payeeFIO: checkParam(filter.payeeFIO),
    payeeCardNumber: checkParam(filter.payeeCardNumber),
    payeePhone: checkParam(filter.payeePhone),
    payerPhone: checkParam(filter.payerPhone),
    paymentAmountMax: checkParam(filter.paymentAmountMax),
    paymentAmountMin: checkParam(filter.paymentAmountMin),
    paymentDateFrom: checkParam(getDateTimeToSubmit(filter.paymentDateFrom)),
    paymentDateTo: checkParam(getDateTimeToSubmit(filter.paymentDateTo)),
    paymentId: checkParam(filter.paymentId),
    paymentState: checkParam(filter.paymentState),
    paymentType: checkParam(filter.paymentType),
  }

  return useMutation({
    mutationFn: () => api.payments.fetchPaymentsList(payload),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось получить данные платежей',
        type: 'error',
      })
    },
    onSuccess: (response) => {
      const _data = response?.payments?.map((i: any) => ({
        ...i,
        paymentType: PAYMENT_TYPE_LABEL[i.paymentType],
        paymentDate: getDateTimeReadFormat(i.paymentDate),
        paymentSource: i.paymentSource
          ? i.paymentSource
          : i.paymentType === 'WITHDRAW_TO_CARD'
          ? 'Внутренний счёт'
          : i.paymentSource,
        state: PAYMENT_STATE_LABEL[i.state] || i.state,
      }))

      exportExcelFile(_data, {
        sheetName: 'Payments',
        columns,
      })
    }
  })
}
